import Vue from 'vue'
import Vuex from 'vuex'

import customizer from './customizer'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        customizer,
    },
    strict: true
})
